var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"bgcObrigado"},[_c('v-col',{staticClass:"flex-column d-flex justify-center align-center",attrs:{"cols":"12","md":"12"}},[_c('h1',[_vm._v("Obrigado por se cadastrar")]),_c('p',[_vm._v(" Em breve enviaremos um e-mail com as novidades da Ribus. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }